import * as React from 'react';

import htmlSerializer, {
  HtmlSerializerProps,
} from '../../utils/html-serializer';

import { BrazeCustomEvent } from './prescreen-consumer';

interface CustomPrescreenProps {
  content: HtmlSerializerProps['content'][];
  onClose: () => void;
  onURLButtonClick: (
    url: string,
    target?: '_self' | '_blank',
    buttonId?: string
  ) => void;
  buttonColor?:
    | 'primary'
    | 'secondary'
    | 'overlay'
    | 'tertiary'
    | 'proBusiness'
    | 'premium'
    | 'proJobs';
  sendBrazeCustomEvent?: (payload: BrazeCustomEvent) => void;
  sendBrazeAltImageMissingEvent?: (payload: BrazeCustomEvent) => void;
}

const CustomPrescreen = ({
  content,
  onClose,
  onURLButtonClick,
  sendBrazeCustomEvent,
  sendBrazeAltImageMissingEvent,
  buttonColor,
}: CustomPrescreenProps): JSX.Element => {
  return (
    <React.Fragment>
      {content.map((content, index) =>
        htmlSerializer({
          content,
          key: `customHTML-${index}`,
          onClose,
          onURLButtonClick,
          buttonColor,
          sendBrazeCustomEvent,
          sendBrazeAltImageMissingEvent,
        })
      )}
    </React.Fragment>
  );
};

export default CustomPrescreen;
